// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivityGroups_wrapper__Q5rny","buttonWrap":"ActivityGroups_buttonWrap__k4PLr","cancelBtn":"ActivityGroups_cancelBtn__UT+Ff"};